import React from "react";
import styles from "./filterItem/FilterItem.module.scss";

const FilterItem = ({
                      isActiveItem = true,
                      children,
                      id,
                      handleRemoveItem,
                      handleTriggerDisableFilterItem,
                      isActive = true,
                      readOnly = false,
                      onClick,
                      halfWidth,
                      themeColor
                    }) => {

  const handleRemove = (e, id) => {
    e.stopPropagation();
    handleRemoveItem(id)
  }

  const handleDisable = (e, id) => {
    e.stopPropagation();
    handleTriggerDisableFilterItem(id);
  }

  return (
    <>
      {
        !readOnly ?
          <div
            className={[styles.FilterItem, (!isActiveItem || !isActive ? styles.disable : null), (!isActive ? styles.noPointerEvents : null), 'col-sm-2'].join(' ')}>
            <div>
              {children}
            </div>
            <div className={[styles.icons, 'd-flex align-items-center justify-content-end'].join(' ')}>
              <div onClick={(event) => handleRemove(event, id)} className={'mr-2'}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.7966 7.19617L7.20264 10.7902" stroke={themeColor ? themeColor : "#FF0053"} stroke-width="1.2" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M10.7977 10.7923L7.20074 7.19458" stroke={themeColor ? themeColor : "#FF0053"} stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M12.2509 2.06262H5.74912C3.48337 2.06262 2.06287 3.66687 2.06287 5.93712V12.0631C2.06287 14.3334 3.47662 15.9376 5.74912 15.9376H12.2501C14.5234 15.9376 15.9379 14.3334 15.9379 12.0631V5.93712C15.9379 3.66687 14.5234 2.06262 12.2509 2.06262Z"
                        stroke={themeColor ? themeColor : "#FF0053"} stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div onClick={(event) => handleDisable(event, id)}>
                {
                  isActiveItem ? (
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.32046 10.7751C6.88921 10.3446 6.62671 9.75963 6.62671 9.10338C6.62671 7.78863 7.68571 6.72888 8.99971 6.72888C9.64996 6.72888 10.2485 6.99213 10.6722 7.42263"
                        stroke={themeColor ? themeColor : "#8A0FFF"} stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M11.3286 9.52429C11.1546 10.4918 10.3926 11.2553 9.42584 11.4308" stroke={themeColor ? themeColor : "#8A0FFF"}
                            stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path
                        d="M4.99095 13.1042C3.8007 12.1697 2.79269 10.8047 2.06219 9.10298C2.80019 7.39373 3.81495 6.02123 5.0127 5.07923C6.20295 4.13723 7.5762 3.62573 8.9997 3.62573C10.4314 3.62573 11.8039 4.14473 13.0017 5.09348"
                        stroke={themeColor ? themeColor : "#8A0FFF"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path
                        d="M14.5857 6.74316C15.1017 7.42866 15.5555 8.21991 15.9372 9.10266C14.462 12.5204 11.855 14.5792 8.99971 14.5792C8.35246 14.5792 7.71421 14.4742 7.10071 14.2694"
                        stroke={themeColor ? themeColor : "#8A0FFF"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M14.9152 3.18726L3.08472 15.0178" stroke={themeColor ? themeColor : "#8A0FFF"} stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M11.3711 9.03983C11.3711 10.3493 10.3091 11.4106 8.99959 11.4106C7.69009 11.4106 6.62885 10.3493 6.62885 9.03983C6.62885 7.72958 7.69009 6.66833 8.99959 6.66833C10.3091 6.66833 11.3711 7.72958 11.3711 9.03983Z"
                            stroke={themeColor ? themeColor : "#8A0FFF"} stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M8.9985 14.5162C11.8545 14.5162 14.4668 12.4627 15.9375 9.03973C14.4668 5.61673 11.8545 3.56323 8.9985 3.56323H9.0015C6.1455 3.56323 3.53325 5.61673 2.0625 9.03973C3.53325 12.4627 6.1455 14.5162 9.0015 14.5162H8.9985Z"
                            stroke={themeColor ? themeColor : "#8A0FFF"} stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  )
                }
              </div>
            </div>
          </div>
          :
          <div onClick={onClick}
               className={`${styles.ActiveFiltersItem} ${halfWidth ? styles.halfWidth : styles.fullWidth} ${isActiveItem && isActive ? styles.enable : styles.disable} d-flex justify-content-between`}>
            <div className={styles.title}>
              {children}
            </div>
            <div className={`${styles.bullet} d-flex align-items-center justify-content-center`}>
              <div>

              </div>
            </div>
          </div>
      }
    </>

  )
};

export default FilterItem;